module.exports = __webpack_public_path__ + "img/icon-credencial.4661d94b.svg";